import { BusinessPartners } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 0430. 取引先一覧
 * [GET] /workspaces/:identifier/business_partners
 */
type Props = {
  identifier: string;
  page: number;
  per: number;
  include_invalidity?: boolean;
  display_type?: 'both' | 'sales' | 'purchase';
};

const businessPartners = (props: Props): Promise<BusinessPartners> => {
  return axios.get(`/api/workspaces/${props.identifier}/business_partners`, { params: props });
};

export const useBusinessPartners = (props: Props) => {
  return useQuery({
    queryKey: [
      'workspaces',
      props.identifier,
      'business_partners',
      'page',
      props.page,
      props.per,
      props.display_type || 'both',
    ],
    queryFn: () => businessPartners(props),
  });
};

export const useInvalidateBusinessPartners = (identifier: string) => {
  const invalidate = async () => {
    await queryClient.invalidateQueries({ queryKey: ['workspaces', identifier, 'business_partners'] });
  };

  return { invalidate };
};
